// extracted by mini-css-extract-plugin
export default {"question":"Y_cM","titleLabel":"Y_cW","prosCons":"Y_cX","pros":"Y_cY","cons":"Y_cZ"};